@if ({
  order: order$ | async,
  errorOrder: errorOrder$ | async
  }; as type) {
  @if (type.order || type.errorOrder) {
    <div [ngClass]="container">
      <!-- BODY -->
      <div class="cx-order-history-body">
        @if (!type.errorOrder && type.order != null > 0) {
          <!-- {{type.order | json}} -->
          <div class="header">
            <div class="row">
              <div class="col-sm-3">
                <div class="label">
                  {{ 'customOrderHistory.detail.orderNumber' | cxTranslate }}
                </div>
              </div>
              <div class="col-sm-3">
                <div class="value">
                  {{ type.order.code }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="label">
                  {{ 'customOrderHistory.detail.date' | cxTranslate }}
                </div>
              </div>
              <div class="col-sm-3">
                <div class="value">
                  {{ type.order.formattedOrderDate }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="label">
                  {{ 'customOrderHistory.detail.note' | cxTranslate }}
                </div>
              </div>
              <div class="col-sm-3">
                <div class="value">
                  {{ type.order.customerReference }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="label">
                  {{ 'customOrderHistory.detail.shippingCosts' | cxTranslate }}
                </div>
              </div>
              <div class="col-sm-3">
                <div class="value">
                  {{ type.order.shippingCostsData?.formattedValue }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="label">
                  {{ 'customOrderHistory.detail.totalPrice' | cxTranslate }}
                </div>
              </div>
              <div class="col-sm-3">
                <div class="value">
                  {{ type.order.totalPriceData?.formattedValue }}
                </div>
              </div>
            </div>
          </div>
          <div class="actions row">
            @if (type.order.updateable && !isUpdateMode && canEdit) {
              <div
                class="col-sm-3"
                >
                <button
                  class="btn btn-secondary btn-block mb-3"
                  type="button"
                  (click)="onUpdateMode()"
                  >
                  {{ 'customOrderHistory.buttons.update' | cxTranslate }}
                </button>
              </div>
            }
            @if (type.order.cancelable && canEdit) {
              <div class="col-sm-3">
                <button
                  class="btn btn-secondary btn-block mb-3"
                  type="button"
                  (click)="onCancelOrder(confirmationDelete)"
                  >
                  {{ 'customOrderHistory.buttons.cancel' | cxTranslate }}
                </button>
              </div>
            }
            <div class="col-sm-3">
              <button
                class="btn btn-secondary btn-block mb-3"
                type="button"
                (click)="onExport()"
                >
                {{ 'customOrderHistory.buttons.export' | cxTranslate }}
              </button>
            </div>
            <div class="col-sm-3">
              <button
                class="btn btn-secondary btn-block mb-3"
                type="button"
                (click)="goToOrderOverview()"
                >
                {{ 'customOrderHistory.buttons.back' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="cx-order-history-sort">
            <div class="form-group row">
              <label for="orders" class="col-xl-2 col-form-label">{{
                'customOrderHistory.sortOptions.label' | cxTranslate
              }}</label>
              <ng-select
                id="sortOptions"
                class="col-xl-2"
                [searchable]="false"
                [clearable]="false"
                (change)="onChangeSort()"
                [(ngModel)]="selectedSortOption"
                >
                @for (sort of sortOptions; track sort) {
                  <ng-option [value]="sort">{{
                    'customOrderHistory.sortOptions.' + sort | cxTranslate
                  }}</ng-option>
                }
              </ng-select>
              <label for="sortDirections" class="col-xl-2 col-form-label">{{
                'customOrderHistory.sortDirections' | cxTranslate
              }}</label>
              <div class="col-xl-2 col-form-label">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="sortDirection"
                    id="sortDirectionDesc"
                    value="desc"
                    ng-control="sortDirection"
                    [(ngModel)]="sortDirection"
                    (change)="onChangeSort()"
                    />
                    <label class="form-check-label" for="sortDirectionDesc">
                      {{ 'customOrderHistory.sortDirection.desc' | cxTranslate }}
                    </label>
                  </div>
                </div>
                <div class="col-xl-2 col-form-label">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="sortDirection"
                      id="sortDirectionAsc"
                      value="asc"
                      ng-control="sortDirection"
                      [(ngModel)]="sortDirection"
                      (change)="onChangeSort()"
                      />
                      <label class="form-check-label" for="sortDirectionAsc">
                        {{ 'customOrderHistory.sortDirection.asc' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <form (ngSubmit)="onSubmit(0)" #f="ngForm" autocomplete="off">
                <!-- TABLE -->
                <table class="table cx-order-history-table">
                  <thead class="cx-order-history-thead-mobile">
                    <th scope="col" class="position">
                      {{ 'customOrderHistory.position' | cxTranslate }}
                    </th>
                    <th scope="col" class="status">
                      {{ 'customOrderHistory.status' | cxTranslate }}
                    </th>
                    <th scope="col" class="productcode">
                      {{ 'customOrderHistory.productCode' | cxTranslate }}
                    </th>
                    <th scope="col" class="description">
                      {{ 'customOrderHistory.description' | cxTranslate }}
                    </th>
                    <th scope="col" class="orderedquantity">
                      {{ 'customOrderHistory.orderedQuantity' | cxTranslate }}
                    </th>
                    @if (!isUpdateMode) {
                      <th scope="col" class="deliveredquantity">
                        {{ 'customOrderHistory.deliveredQuantity' | cxTranslate }}
                      </th>
                    }
                    @if (isUpdateMode) {
                      <th scope="col" class="deliveredquantity">
                        {{ 'customOrderHistory.deliveredQuantityNow' | cxTranslate }}
                      </th>
                    }
                    @if (isUpdateMode) {
                      <th
                        scope="col"
                        class="deliveredquantitynew"
                        >
                        {{ 'customOrderHistory.deliveredQuantityNew' | cxTranslate }}
                      </th>
                    }
                    <th scope="col" class="netprice">
                      {{ 'customOrderHistory.netPrice' | cxTranslate }}
                    </th>
                    <th scope="col" class="planneddelivery">
                      {{ 'customOrderHistory.plannedDelivery' | cxTranslate }}
                    </th>
                    <th scope="col" class="button">&nbsp;</th>
                  </thead>
                  <tbody>
                    @for (entry of entries; track entry; let i = $index) {
                      <tr>
                        <!-- entry position -->
                        <td class="position">
                          <div class="d-md-none cx-order-history-label">
                            {{ 'customOrderHistory.position' | cxTranslate }}
                          </div>
                          <div class="cx-order-history-value">
                            {{ entry?.position }}
                          </div>
                        </td>
                        <!--Order Status-->
                        <td class="status">
                          <div class="d-md-none cx-order-history-label">
                            {{ 'customOrderHistory.status' | cxTranslate }}
                          </div>
                          <div class="cx-order-history-value">
                            @if (entry?.orderState != 'UNKNOWN') {
                              <img
                        src="assets/images/orderhistory/state_{{
                          entry?.orderState | lowercase
                        }}.gif"
                                alt="{{ entry?.orderState }}"
                        title="{{
                          'customOrderHistory.states.' + entry?.orderState
                            | cxTranslate
                        }}"
                                />
                            }
                          </div>
                        </td>
                        <!-- entry product code -->
                        <td class="product-code">
                          <div class="d-md-none cx-order-history-label">
                            {{ 'customOrderHistory.productCode' | cxTranslate }}
                          </div>
                          <div class="cx-order-history-value">
                            <a
                              class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'product',
                            params: { code: entry.productCode }
                          } | cxUrl
                        "
                              class="cx-order-history-value"
                              >
                              {{ entry?.productCode }}
                            </a>
                          </div>
                        </td>
                        <!-- entry description -->
                        <td class="description">
                          <div class="d-md-none cx-order-history-label">
                            {{ 'customOrderHistory.description' | cxTranslate }}
                          </div>
                          <div class="cx-order-history-value">
                            <a
                              class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'product',
                            params: { code: entry.productCode }
                          } | cxUrl
                        "
                              class="cx-order-history-value"
                              >
                              {{ entry?.description }}
                            </a>
                          </div>
                        </td>
                        <!-- entry ordered quantity -->
                        <td class="ordered-quantity">
                          <div class="d-md-none cx-order-history-label">
                            {{ 'customOrderHistory.orderedQuantity' | cxTranslate }}
                          </div>
                          <div class="cx-order-history-value">
                            {{ entry?.orderedQuantity }}
                          </div>
                        </td>
                        <!-- entry delivered quantity -->
                        <td class="delivered-quantity">
                          <div class="d-md-none cx-order-history-label">
                            {{ 'customOrderHistory.deliveredQuantity' | cxTranslate }}
                          </div>
                          <div class="cx-order-history-value">
                            {{ entry?.deliveredQuantity }}
                          </div>
                        </td>
                        <!-- entry delivered quantity new-->
                        @if (isUpdateMode) {
                          <td class="delivered-quantity-new">
                            <div class="d-md-none cx-order-history-label">
                              {{
                              'customOrderHistory.deliveredQuantityNew' | cxTranslate
                              }}
                            </div>
                            <div class="cx-order-history-value">
                              <input
                                type="number"
                                class="form-control"
                                name="deliveredQuantityNew[{{ i }}]"
                                ngModel
                                min="0"
                                />
                              </div>
                            </td>
                          }
                          <!-- entry netPrice -->
                          <td class="net-price">
                            <div class="d-md-none cx-order-history-label">
                              {{ 'customOrderHistory.netPrice' | cxTranslate }}
                            </div>
                            <div class="cx-order-history-value">
                              {{ entry?.totalPriceData.formattedValue }}
                            </div>
                          </td>
                          <!--Planned Delivery Week-->
                          <td class="planned-delivery">
                            <div class="d-md-none cx-order-history-label">
                              {{ 'customOrderHistory.plannedDelivery' | cxTranslate }}
                            </div>
                            <div class="cx-order-history-value">
                              {{ entry?.formattedDeliverKW }}
                            </div>
                          </td>
                          <!--Entry Buttons-->
                          @if (canEdit) {
                            <td class="button">
                              @if (entry.cancelable || isUpdateMode) {
                                <div
                                  class="d-md-none cx-order-history-label"
                                ></div>
                              }
                              @if (entry.cancelable && !isUpdateMode) {
                                <a
                                  class="delete"
                      title="{{
                        'customOrderHistory.buttons.cancel' | cxTranslate
                      }}"
                      (click)="
                        onCancelOrderEntry(
                          entry?.position,
                          confirmationPositionDelete
                        )
                      "
                                  >
                                  <cx-icon type="TRASH"></cx-icon>
                                </a>
                              }
                              @if (isUpdateMode) {
                                <a
                                  class="update"
                      title="{{
                        'customOrderHistory.buttons.updateEntry' | cxTranslate
                      }}"
                                  (click)="onSubmit(entry?.position)"
                                  >
                                  <cx-icon type="PENCIL"></cx-icon>
                                </a>
                              }
                            </td>
                          }
                        </tr>
                      }
                      @if (canEdit && isUpdateMode) {
                        <tr>
                          <td colspan="7">&nbsp;</td>
                          <td colspan="3">
                            <button
                              class="btn btn-secondary btn-block"
                              type="button"
                              (click)="onSubmit(0)"
                              >
                              {{ 'customOrderHistory.buttons.updateAll' | cxTranslate }}
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </form>
              } @else {
                <div [ngClass]="'cx-order-history-no-order row'">
                  <div [ngClass]="'col-sm-12 col-md-6 col-lg-4'">
                    <div>{{ 'customOrderHistory.noOrder' | cxTranslate }}</div>
                    <a
                      [routerLink]="{ cxRoute: 'orders' } | cxUrl"
                      routerLinkActive="active"
                      class="btn btn-primary btn-block"
                      >{{ 'customOrderHistory.returnToOverview' | cxTranslate }}</a
                      >
                    </div>
                  </div>
                }
                <!-- NO ORDER CONTAINER -->
              </div>
            </div>
          } @else {
            <cx-spinner></cx-spinner>
          }
        }

        <ng-template #confirmationDelete let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-title">
              {{ 'customOrderHistory.dialog.orderDelete.title' | cxTranslate }}
            </h4>
            <button
              type="button"
              class="close"
              aria-describedby="modal-title"
              (click)="modal.dismiss('Cross click')"
              >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              <strong>{{
                'customOrderHistory.dialog.orderDelete.body' | cxTranslate
              }}</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="modal.dismiss('cancel click')"
              >
              {{ 'customOrderHistory.buttons.cancelText' | cxTranslate }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="modal.close('Ok click')"
              >
              {{ 'customOrderHistory.buttons.ok' | cxTranslate }}
            </button>
          </div>
        </ng-template>

        <ng-template #confirmationPositionDelete let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-title">
              {{ 'customOrderHistory.dialog.orderPositionDelete.title' | cxTranslate }}
            </h4>
            <button
              type="button"
              class="close"
              aria-describedby="modal-title"
              (click)="modal.dismiss('Cross click')"
              >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              <strong>{{
                'customOrderHistory.dialog.orderPositionDelete.body' | cxTranslate
              }}</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="modal.dismiss('cancel click')"
              >
              {{ 'customOrderHistory.buttons.cancelText' | cxTranslate }}
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              (click)="modal.close('Ok click')"
              >
              {{ 'customOrderHistory.buttons.ok' | cxTranslate }}
            </button>
          </div>
        </ng-template>
